import React from "react";
import { Modal, Row, Col, Button } from "antd";
import styles from "./MemberProfileModals.module.scss";
import { useWindowSize } from "../../../../hooks/useWindowSize";

type Props = {
  serviceUserName: string;
  visible: boolean;
  setVisibility: Function;
  handleRemoveServiceUser: () => void;
};

function RemoveServiceUserModal({
  serviceUserName,
  visible,
  setVisibility,
  handleRemoveServiceUser,
}: Props) {
  const { width } = useWindowSize();

  function handleClose() {
    setVisibility(false);
  }

  return (
    <Modal
      visible={visible}
      className={styles.removeServiceUserModalContainer}
      centered={width < 992}
      width={width < 992 ? "unset" : "547px"}
      footer={
        <Row justify="center" gutter={[10, 10]}>
          <Button className={styles.cancelBtn} onClick={handleClose}>
            Cancel
          </Button>
          <Button
            className={styles.yesRemoveBtn}
            onClick={handleRemoveServiceUser}
          >
            Yes, Remove
          </Button>
        </Row>
      }
    >
      <Row justify="center" gutter={[0, 20]}>
        <Col className={styles.title}>Remove Service User</Col>
        <Col span={24} className={styles.description}>
          Are you sure you want to remove <strong>{serviceUserName}</strong>{" "}
          from your Service Users?
        </Col>
      </Row>
    </Modal>
  );
}

export default RemoveServiceUserModal;
